exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group-item.show[data-v-5163961d]{\n\tdisplay: block;\n}\n.list-group-item.label.hide[data-v-5163961d]{\n\tdisplay: block;\n}\n.list-group-item.hide[data-v-5163961d]{\n\tdisplay: none;\n}\n#widgetSubtabs .nav-justified .nav-item .nav-link[data-v-5163961d]{\n\tpadding: 10px 5px !important;\n\tborder-radius: 10px !important;\n}\n", ""]);

// exports
